import { FCWithChildren } from 'common/types';
import TrackView, { TrackViewProps } from 'features/Analytics/TrackView';
import * as ContentLayout from 'layouts/ContentLayout';

interface PageContainerProps {
  trackViewProps: TrackViewProps;
}

const PageContainer: FCWithChildren<PageContainerProps> = ({
  children,
  trackViewProps,
}) => (
  <>
    <TrackView {...trackViewProps} />

    <ContentLayout.Root>
      <ContentLayout.Body size="md">{children}</ContentLayout.Body>
    </ContentLayout.Root>
  </>
);

export default PageContainer;
